<div class="flex flex-col -m-6">

  <!-- Header -->
  <div
    class="flex flex-0 sticky -top-6 z-50 items-center justify-between h-16 pr-3 sm:pr-5 pl-6 sm:pl-8 bg-primary text-on-primary">
    <div class="text-lg font-medium">
      {{ 'categoryTreeOf' | transloco }} {{ dataDialog.masterName }}
    </div>
    <div class="flex flex-col justify-end items-end flex-auto ml-6">
      <div class="flex p-4">
        <!-- Save edit -->
        @if (viewEdit) {
          <button mat-raised-button class="mr-4" color="primary" (click)="viewEdit = false">{{
            'saveEdit' | transloco
          }}</button>
        }

        <!-- Edit -->
        @if (!viewEdit) {
          <button mat-raised-button class="mr-4" color="primary" (click)="viewEdit = true">{{
            'editTree' | transloco
          }}</button>
        }

        <!-- Save tree -->
        @if (!viewEdit) {
          <button mat-raised-button class="mr-4" color="accent" (click)="flushTree()">{{
            'saveChangesAndCategories' | transloco
          }}</button>
        }

        <!-- Remove tree -->
        @if (viewEdit) {
          <button mat-raised-button class="mr-4" color="warn" (click)="removeTree()">{{
            'removeTreeButton' | transloco
          }}</button>
        }
      </div>
    </div>
    <div class="flex justify-end items-end">
      <button mat-icon-button [tabIndex]="-1" (click)="closeDialog()">
        <mat-icon class="text-current" svgIcon="heroicons_outline:x"></mat-icon>
      </button>
    </div>
  </div>

  <mat-tree class="mt-2 ml-8" [dataSource]="dataSource" [treeControl]="treeControl">
    <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding class="w-full">
      <div class="flex flex-row items-center w-full">
        @if (node.hasChild) {
          <button [ngClass]="{'mb-6': node.errorAddCategoryNode}" mat-icon-button
            matTreeNodeToggle [attr.aria-label]="'Toggle ' + node.item">
            <mat-icon class="mat-icon-rtl-mirror">
              {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
            </mat-icon>
          </button>
        }
        @if (!node.hasChild) {
          <div class="pad"></div>
        }
        @if (!viewEdit) {
          <mat-checkbox [checked]="isChecked(node)" (change)="toggleNode(node)">
          </mat-checkbox>
        }
        <span [ngClass]="{'mb-5': node.errorAddCategoryNode}">{{node.item.name | localize}}</span>
        @if (!node.addingChild && viewEdit) {
          <button mat-icon-button (click)="node.addingChild = true">
            <mat-icon>add</mat-icon>
          </button>
        }
        @if (!node.addingChild && viewEdit && !node.hasChild) {
          <button mat-icon-button
            (click)="removeNode(node)">
            <mat-icon [svgIcon]="'heroicons_outline:trash'"></mat-icon>
          </button>
        }
        @if (node.addingChild) {
          <div class="flex flex-row items-center w-1/3">
            <div class="flex flex-col w-full">
              <div class="flex flex-row">
                <mat-form-field class="w-full ml-2">
                  <mat-form-field appearance="fill" class="ml-1">
                    <mat-label class="mt-2">{{ 'newTreeNode' | transloco }}</mat-label>
                    <input matInput #itemValue [formControl]="node.addCategoryNodeControl">
                  </mat-form-field>
                  <button class="mt-2 ml-2" mat-stroked-button color="primary"
                    (click)="addNewItem(node, itemValue.value)"> {{
                    'save' | transloco }}
                  </button>
                  @if (node.addingChild) {
                    <button class="mt-2 ml-2" mat-stroked-button
                      (click)="cancelAddingChild(node)"> {{ 'cancel' | transloco }}
                    </button>
                  }
                </mat-form-field>
              </div>
              <div class="flex flex-row ml-4">
                @if (!node.addCategoryNodeControl.disabled && node.addCategoryNodeControl.errors) {
                  <mat-error
                    >
                    @if (node.errorAddCategoryNode) {
                      {{ 'errorAddCategoryNode' | transloco }}
                    }
                  </mat-error>
                }
              </div>
            </div>
          </div>
        }
      </div>
    </mat-tree-node>
  </mat-tree>

  @if (viewEdit) {
    <div class="flex flex-row items-center mt-2 ml-10">
      <div class="flex flex-col w-full">
        <div class="flex flex-row">
          <mat-form-field class="w-1/3">
            <mat-form-field class="w-full" appearance="fill">
              <mat-label class="flex flex-row block">{{ 'newMainTreeNode' | transloco }}</mat-label>
              <input matInput #itemValue [formControl]="addRootCategoryNodeControl">
            </mat-form-field>
            <button mat-button (click)="createMainNode(itemValue.value)">{{ 'save' | transloco }}</button>
          </mat-form-field>
        </div>
        @if (!addRootCategoryNodeControl.disabled && addRootCategoryNodeControl.errors) {
          <mat-error class="ml-3">
            @if (errorAddRootCategoryNode) {
              {{ 'errorAddCategoryNode' | transloco }}
            }
          </mat-error>
        }
      </div>
    </div>
  }
</div>